import {
  Box,
  Button,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import Model from "../../../Model/Model";
import TextFieldInput from "../../../Input/TextField/TextFieldInput";
import CModel from "../../Model/CModel";
import ModelBox from "../../../Model/Model";

export default function RejectionModel({
  openRejectionReason,
  setOpenRejectionReason,
  handleRejectionSubmit,
}) {
  const { t } = useTranslation();
  const { textGray, oliveGreen } = useThemePalette();
  const openEdit = () => {
    setOpenRejectionReason((prevState) => ({
      ...prevState,
      type: "edit",
    }));
  };

  return (
    <Stack flexDirection={"row"}>
      <CModel
        titleStyle={{
          fontSize: "32px",
          fontWeight: 500,
          color: openRejectionReason.type === "reject" && "red",
        }}
        title={
          openRejectionReason.type === "view"
            ? t("vendors.label_reject_reason")
            : openRejectionReason.type === "edit"
              ? t("vendors.label_edit_rejection_reason")
              : t("vendors.label_reject_vendor")
        }
        openVar={openRejectionReason.action}
        closeFunc={() =>
          setOpenRejectionReason({ action: false, reason: "", type: "" })
        }
      >
        <Stack gap={3}>
          {openRejectionReason.type === "reject" && (
            <Typography fontWeight={500} fontSize={20}>
              {t("vendors.label_write_rejection_reason")}
            </Typography>
          )}
          <TextField
            InputProps={{
              readOnly: openRejectionReason.type === "view" && true,
            }}
            multiline
            rows={4}
            value={openRejectionReason.reason}
            onChange={(e) =>
              setOpenRejectionReason((prevState) => ({
                ...prevState,
                reason: e.target.value,
              }))
            }
          ></TextField>
          <Stack flexDirection={"row"} gap={3} justifyContent={"center"}>
            <Button
              variant={"outlined"}
              sx={{
                width: "5%",
                color: "black",
                borderColor: "black",
                "&:hover": { color: "black", borderColor: "black" },
              }}
              onClick={() => {
                setOpenRejectionReason({ action: false, reason: "", type: "" });
              }}
            >
              {t("vendors.action_cancel")}
            </Button>
            <Button
              variant={"contained"}
              sx={{
                width: "5%",
                background: oliveGreen,
                "&:hover": { background: oliveGreen },
              }}
              onClick={
                openRejectionReason.type === "view"
                  ? openEdit
                  : handleRejectionSubmit
              }
            >
              {openRejectionReason.type === "view"
                ? t("vendors.action_edit")
                : t("vendors.action_submit")}
            </Button>
          </Stack>
        </Stack>
      </CModel>
    </Stack>
  );
}
